import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'counterparty_name', label: 'Tenant' },
  { key: 'lease_start_date', label: 'Lease Start' },
  { key: 'lease_end_date', label: 'Lease End' },
  { key: 'rent_review_date', label: 'Rent Review' },
  { key: 'insurance_expiry_date', label: 'Insurance Expiry' },
  { key: 'lease_expiry_bucket', label: 'Lease Expiry' },
  { key: 'gross_rental_yield', label: 'Gross Yield', align: 'right', type: 'percent' },
  { key: 'occupancy_status', label: 'Occupancy' },
];

export function PropertyLeaseRegisterReport() {
  return (
    <ReportView
      title="Property Lease & Expiry Register"
      description="Every property holding with lease dates, insurance expiry, a forward-looking expiry bucket, gross rental yield, and occupancy status."
      endpoint="/reports/investments/property-lease-register"
      columns={COLUMNS}
      xlsx
    />
  );
}
